<template>
  <MDBCardBody class="card--height">
    <MDBCardTitle class="text-start font-35 mb-3">
      <div v-html="$t('login.title')"></div>
    </MDBCardTitle>
    <template v-if="currentLocale === 'nl-BE'">
      <p class="font-16">
        <b>Heeft u al een account?</b><br/>Log in met uw e-mailadres en wachtwoord.<br/><br/><b>Bent u nieuw hier?</b><br/>Als u een nieuwe gebruiker bent, registreer u dan.<br/><br/><b>Heeft u een vraag?</b><br/>Neem dan contact met ons op: plusbelux@bridgestone.eu
      </p>
    </template>
    <template v-else-if="currentLocale === 'fr-BE'">
      <p class="font-16">
        <b>Vous avez déjà un compte?</b><br/>Connectez-vous à l'aide de votre adresse e-mail et de votre mot de passe.<br/><br/><b>Vous êtes nouveau ici?</b><br/>Cliquez ci-dessous pour créer votre compte.<br/><br/><b>Une question?</b><br/>Veuillez nous écrire à plusbelux@bridgestone.eu
      </p>
    </template>
    <ButtonMediumVue
        className="btn btn-danger btn-lg d-flex justify-content-center font-12 btn-position ripple-surface"
        div-class-name="text-white fw-bold margin-reset font-16"
        property1="default"
        :text="$t('login.buttons.action')"
        @click="handleSsoRedirection"
        :disableState="loading"
    />
    <!-- Trigger Language Selector -->
    <button
        v-if="showLanguageButton"
        class="btn btn-primary mt-3"
        @click="$emit('toggleLanguageSelector')"
    >
      {{ $t("login.buttons.changeLanguage") }}
    </button>
  </MDBCardBody>
</template>

<script setup>
import { computed, defineProps } from "vue";
import { useI18n } from "vue-i18n";
import {
  MDBCardBody,
  MDBCardTitle
} from "mdb-vue-ui-kit";
import ButtonMediumVue from "@/components/General/Buttons/ButtonMedium.vue";

const props = defineProps({
  loading: Boolean,
  handleSsoRedirection: Function,
  tenantConfig: Object,
  availableLocales: { type: Array, required: true },
});

const { locale } = useI18n();
const currentLocale = computed(() => locale.value);
const showLanguageButton = computed(() => props.availableLocales.length > 1);
</script>

<style scoped>
.btn-primary {
  margin-top: 20px;
}
</style>
